export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white">
      <div className="border-b border-gray-100 bg-gray-50 px-4 py-16 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl">
          <p className="mb-3 text-xs font-bold uppercase tracking-[0.18em] text-orange-500">Legal</p>
          <h1 className="text-3xl font-extrabold tracking-tight text-black sm:text-4xl">Privacy Policy</h1>
          <p className="mt-3 text-sm text-gray-500">Last updated: April 2026</p>
        </div>
      </div>

      <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="space-y-10 text-[15px] leading-relaxed text-gray-600">

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">1. Overview</h2>
            <p>Focus Traffic Plans Pty Ltd (ABN 23 659 805 231) ("we", "us", "our") is committed to protecting the privacy of individuals who interact with us. This Privacy Policy explains how we collect, use, store and disclose personal information in accordance with the <em>Privacy Act 1988</em> (Cth) and the Australian Privacy Principles (APPs).</p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">2. Information We Collect</h2>
            <p>We may collect the following types of personal information:</p>
            <ul className="mt-3 list-disc space-y-2 pl-6">
              <li>Name and contact details (phone number, email address, postal address)</li>
              <li>Company name, ABN and job title</li>
              <li>Project information provided to us for the purpose of preparing traffic management plans or related documents</li>
              <li>Billing and payment information</li>
              <li>Website usage data (see Cookies Policy)</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">3. How We Collect Information</h2>
            <p>We collect personal information directly from you when you contact us by phone, email or through our website contact form, request a quote, engage us for services, or subscribe to communications from us. We may also collect information from third parties such as referral partners or publicly available sources.</p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">4. How We Use Your Information</h2>
            <p>We use your personal information to:</p>
            <ul className="mt-3 list-disc space-y-2 pl-6">
              <li>Provide, manage and improve our services</li>
              <li>Communicate with you about your project or enquiry</li>
              <li>Issue invoices and process payments</li>
              <li>Comply with legal and regulatory obligations</li>
              <li>Send service updates or marketing communications where you have consented</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">5. Disclosure of Information</h2>
            <p>We do not sell, rent or trade your personal information. We may disclose your information to third parties where necessary to deliver our services (for example, to relevant road authorities or councils as part of a permit submission), or where required by law. We may also engage trusted service providers (such as cloud storage or accounting software providers) who handle data on our behalf under strict confidentiality obligations.</p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">6. Data Security</h2>
            <p>We take reasonable steps to protect your personal information from misuse, interference, loss, and unauthorised access, modification or disclosure. Our systems are secured and access is limited to authorised personnel.</p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">7. Retention</h2>
            <p>We retain personal information for as long as necessary to fulfil the purposes for which it was collected, and as required by applicable law. When information is no longer needed, it is securely deleted or de-identified.</p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">8. Your Rights</h2>
            <p>You have the right to access, correct or request deletion of personal information we hold about you. To make a request, please contact us using the details below. We will respond within a reasonable timeframe.</p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">9. Changes to This Policy</h2>
            <p>We may update this Privacy Policy from time to time. The current version will always be available on our website. We encourage you to review it periodically.</p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-bold text-black">10. Contact Us</h2>
            <p>If you have questions about this Privacy Policy or wish to make a privacy complaint, please contact us at <a href="mailto:info@focustrafficplans.com.au" className="text-orange-500 underline">info@focustrafficplans.com.au</a> or call <a href="tel:1300118170" className="text-orange-500 underline">1300 118 170</a>.</p>
          </section>

        </div>
      </div>
    </div>
  );
}
